export const PROJECT_STATS = {
  guestsHosted: { value: 500, suffix: "+", },
  returnGuests: { value: 60, suffix: "%" },
  customerSatisfaction: { value: 4.9, suffix: "/5", decimal: true },
};